import determineTarget from './determine-target';
import toggleElement from './toggle-element';
import setupFocusTrap from './focus-trap';

export default function setupTabs() {
	document.querySelectorAll( '.js-tab-set' ).forEach( tabSet => {
		const tabs = tabSet.querySelectorAll( '.js-tab[aria-controls], .js-tab[data-target]' );
		const panels = tabSet.querySelectorAll( '.js-tab-panel' );

		// Mark all panels as hidden to start
		panels.forEach( panel => {
			panel.setAttribute( 'aria-hidden', true );
		} );

		function switchToTab( tab, focus ) {
			const panel = determineTarget( tab );

			toggleElement( panel, true, focus );

			panels.forEach( _panel => {
				if ( _panel.getAttribute( 'aria-hidden' ) === 'false' && _panel !== panel ) {
					toggleElement( _panel, false );
				}
			} );

			return panel;
		}

		tabs.forEach( tab => {
			tab.addEventListener( 'click', event => {
				event.preventDefault();
				const panel = switchToTab( tab, 'focus' );
				history.replaceState( {}, '', `#${ panel.id }` );
			} );
		} );

		setupFocusTrap( tabSet, tabs, {
			arrowKeys: true,
			assumeFocusable: true,
		}, switchToTab );

		const currentId = location.hash.replace( '#', '' );
		const currentTab = [ ...tabs ].find( tab => tab.getAttribute( 'aria-controls' ) === currentId ) || tabs[ 0 ];

		switchToTab( currentTab );
	} );
}
